import { gql } from '@apollo/client';

export const GET_PROFILE_DETAIL = gql`
  query MyQuery {
    viewer {
      personId
      phoneNumber
      personInfo {
        first
        last
        gender
        birthdate
        email
        headshot
      }
      addressInfo {
        street1
        street2
        city
        stateOrProvince
        postalCode
        postalAdditional
        countryId
        timezone
        isValid
        cityLat
        cityLong
        addressLat
        addressLong
      }
    }
    getUserChildren {
      id
      birthDate
      gender
    }
    getPersonCategoryInterests {
      categoryId
      interestId
      personId
      name
      slug
      order
      assetId
      isDeleted
      created
      modified
      isInterested
      iconUrl
    }
  }
`;

export const GET_PARTICIPATION_HISTORY = gql`
  query MyQuery($page: Int!, $size: Int!) {
    getParticipationHistory(page: $page, size: $size) {
      total
      data {
        participationType
        ends
        id
        name
        slug
        sponsor {
          assetResponse {
            assetType
            basename
            description
            hlsPlaylistUrl
            id
            mimeType
            mp4Url
            name
            sponsorId
            thumbNail
            webmUrl
          }
          name
          slug
        }
        memberSince
        sponsorId
        starts
      }
    }
  }
`;

export const GET_PERSON_INFO = gql`
  query MyQuery {
    viewer {
      personId
      phoneNumber
      personInfo {
        first
        last
        gender
        birthdate
        email
        headshot
        displayName
      }
      addressInfo {
        street1
        street2
        city
        stateOrProvince
        postalCode
        postalAdditional
        countryId
        timezone
        isValid
        cityLat
        cityLong
        addressLat
        addressLong
      }
    }
  }
`;

export const GET_PERSONAL_FEED = gql`
  query MyQuery(
    $pageNo: Int!
    $size: Int!
    $onlyMyFeeds: Boolean!
    $sort: String
  ) {
    getPersonalFeed(
      pageNo: $pageNo
      size: $size
      onlyMyFeeds: $onlyMyFeeds
      sort: $sort
    ) {
      count
      feeds {
        id
        isFeatured
        isPrioritised
        feedType
        personInfo {
          id
          displayName
          headshot
        }
        feedInfo {
          eventId
          commentCount
          created
          likeCount
          liked
          reported
        }
        commentInfo {
          id
          body
        }
        reviewInfo {
          id
          title
          body
          rating
          assetInfo {
            id
            basename
            mimeType
            url
            thumbnailUrl
            hlsPlaylistUrl
            mp4Url
            webmUrl
            created
            caption
          }
          reviewFeedProductInfo {
            id
            name
            assetUrl
          }
        }
        assetInfo {
          id
          basename
          mimeType
          url
          thumbnailUrl
          hlsPlaylistUrl
          mp4Url
          webmUrl
          created
          caption
          type
        }
        sponsor {
          id
        }
      }
    }
  }
`;
